module.exports = __webpack_public_path__ + "img/house_05.6674776f.jpg";